import React, { useState } from 'react';
import { api, formatApiError } from '../../lib/api';

/**
 * TranslateButton — calls /api/admin/translate with the given value and
 * passes back the translated result via onTranslated.
 *
 * value can be: string | string[] | array of {label,value}/{caption}
 */
const TranslateButton = ({ value, onTranslated, targetLang = 'en', label = 'Traduire EN', testId, disabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isEmpty = (v) => {
    if (v == null) return true;
    if (typeof v === 'string') return !v.trim();
    if (Array.isArray(v)) return v.length === 0 || v.every((x) => isEmpty(x));
    return false;
  };

  const onClick = async () => {
    if (isEmpty(value)) {
      setError('Rien à traduire');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/admin/translate', { value, target_lang: targetLang });
      onTranslated(data.value);
    } catch (e) {
      // Friendly message for quota/budget exhaustion
      const status = e?.response?.status;
      if (status === 429) {
        setError('Quota IA dépassé. Réessayez plus tard.');
      } else {
        setError(formatApiError(e));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="inline-flex flex-col items-start">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        data-testid={testId}
        title="Traduire avec l'IA (Claude)"
        className="text-[10px] font-light tracking-wider uppercase border border-gray-300 px-2 py-1 hover:border-[#d94e47] hover:text-[#d94e47] transition-colors disabled:opacity-50"
      >
        {loading ? '...' : label}
      </button>
      {error && <span className="text-[10px] text-[#d94e47] mt-1">{error}</span>}
    </div>
  );
};

export default TranslateButton;
